import {
    DIC
} from '@/const/dic'
// import {
//     validateChinese
// } from '@/util/validate'
// import {
//     formatterTime
// } from '@/util/util'



export const releaseSaleOption = {
    align: "center",
    menuAlign: "center",
    headerAlign: "center",
    border: true,
    expand: false,
    stripe: false,
    showHeader: true,
    // align: 'center',
    index: false,
    selection: true,
    menu: true,
    page: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    columnBtn: false,
    //viewBtn: true,
    menuWidth: '250',
    labelWidth: '150',
    defaultSort: {
        prop: 'createTime',
        order: 'descending'
    },
    column: [{
            label: "产品名称",
            prop: "name",
            type: 'input',
            search: true,
            span: 18
        },
        {
            label: "分销渠道",
            prop: "clientType",
            type: "input",
        },
        {
            label: "分销类型",
            prop: "type",
            type: "select",
            dicData: DIC.PRODUCT_ORDER_TYPE
        },
        {
            label: "分销销量",
            prop: "totalNumber",
            type: "input",
        },
        {
            label: "分销人数",
            prop: "totalHead",
            type: "input",
        },
        {
            label: "分销状态",
            prop: "status",
            type: "select",
            search: true,
            dicData: DIC.SALES_STATUS
        },
        {
            label: "发布时间",
            prop: "createTime",
            type: "datetime",
            // sortable: true,
            valueFormat: "timestamp",
            format: "yyyy-MM-dd HH:mm:ss",
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "更新人",
            prop: "createBy",
            type: "input",
            hide: true,
            addVisdiplay: false,
            editVisdiplay: false,
            width: "110"
        },
    ]
};